import { Dispatch } from "redux";
import { GET_PARAMS } from "./paramHelper";

export const RECEIVE_FEED_OWNER_USERS = "RECEIVE_FEED_OWNER_USERS";
export const RECEIVE_FEED_OWNER_ROWS = "RECEIVE_FEED_OWNER_ROWS";

export interface FeedOwnerRow {
  user: string;
  client_name?: string;
  [key: string]: any;
}

export const fetchFeedOwnerUsers =
  (token: string) => async (dispatch: Dispatch) => {
    const resp = await fetch("/api/feed_owner_report/users", GET_PARAMS(token));
    if (!resp.ok) {
      throw new Error(`Failed to fetch feed owner users: ${resp.status}`);
    }
    const { users }: { users: string[] } = await resp.json();
    return dispatch({ type: RECEIVE_FEED_OWNER_USERS, users });
  };

export const fetchFeedOwnerRows =
  (token: string, user: string) => async (dispatch: Dispatch) => {
    const resp = await fetch(
      `/api/feed_owner_report/?user=${encodeURIComponent(user)}`,
      GET_PARAMS(token)
    );
    if (!resp.ok) {
      throw new Error(`Failed to fetch feed owner rows: ${resp.status}`);
    }
    const { rows }: { rows: FeedOwnerRow[] } = await resp.json();
    return dispatch({ type: RECEIVE_FEED_OWNER_ROWS, user, rows });
  };
